import { colors } from './colors';

export const componentOverrides = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: '12px',
        boxShadow: 'none',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          transform: 'translateY(-1px)',
        },
      },
      containedPrimary: {
        background: colors.primary.main,
        '&:hover': {
          background: colors.primary.dark,
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: '16px',
        border: `1px solid ${colors.custom.cardBorder}`,
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        '&:hover': {
          boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
          transform: 'translateY(-2px)',
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          '&:hover fieldset': {
            borderColor: colors.primary.main,
          },
          '&.Mui-focused fieldset': {
            borderColor: colors.primary.main,
          },
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontWeight: 600,
        borderRadius: '8px',
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        '& .MuiTableCell-head': {
          backgroundColor: colors.custom.backgroundLight,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          fontSize: '12px',
        },
      },
    },
  },
};